// Utils
import { capitalizeFirstLetter } from '@/utils/Data'

export default class ApiError {
  constructor (error) {
    this.error = error.error
    this.message = error.message
    this.arguments = error.arguments
  }

  get field () {
    if (this.arguments != null) {
      return this.parseField(this.arguments.field)
    }
  }

  get isSystemError () {
    return !this.isValidationError
  }

  get isNetworkError () {
    return this.error === ERROR_TYPES.NETWORK
  }

  get isValidationError () {
    return this.arguments != null && this.arguments.field != null
  }

  parseField (field) {
    if (field.includes('.')) {
      return field.split('.')
        .map((fieldName, index) => index !== 0 ? capitalizeFirstLetter(fieldName) : fieldName)
        .join('')
    }

    return field
  }
}

export const ERROR_TYPES = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  NETWORK: 'NETWORK_ERROR'
}
